import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import Moment from 'moment';
import {updateValueInJson, validateUrl, getRoles} from '../../../functions';
import $ from 'jquery';

let totalRegistros = 0;
export default class PuedeInteresarte extends Component {

    state = {
        resource: [],
        response: [],
        error: [],
        security: cookie.load('user'),
        roles: [],
        filters:{
            texto:''
        },
        pagina: 1,
        offRows:0,
        menuGeneral:[],
        agrupador:""
      }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Puede Interesarte</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                Puede Interesarte
                </div>
               <div className="divSector_Panel">
                    <div className="divCatAnadir_Panel">
                        <a href="#" className="btnAnadirCat" onClick={(e) => this.addRegistro(e)}>AÑADIR</a>
                        <div className="divSectorSearch_Panel">
                        <input type="text" placeholder="Buscar..." id="texto_filter" onKeyDown={this._handleKeyDown}/>
                        <input type="submit" defaultValue="Buscar" onClick={(event) => this.callFunctionButton(event)}/>
                        </div>
                        <div className="clear" />
                    </div>	
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <th>N°</th>
                                <th>Título</th>
                                <th>Sector</th>
                                <th>Categoría General</th>
                                <th>Perfil</th>                               
                                <th>Creación</th>
                                <th>Acciones</th>
                            </tr>
                            {
                                (this.state.response.statusCode===200) ?

                                            this.state.resource.length > 0 ?
                                            
                                            this.state.resource.map((resource, index) => (
                                            <tr key={resource.pint_Id}>
                                                <td>{(index + 1) + this.state.offRows}</td>
                                                <td>{resource.pint_Titulo}</td>
                                                <td>{resource.sector}</td>
                                                <td>{resource.categoria_fija}</td>
                                                <td>{resource.perfil_Web}</td>
                                                <td>
                                                {Moment(resource.pint_FechaCreacion).format('DD/MM/YYYY')}
                                                </td>
                                                <td>                                        
                                                    <div className="divBtnAcciones">
                                                    <a href="#" className={resource.pint_Activo ? "btnPageModuloVer" : "btnPageModuloInactivo"} onClick={(event) => this.actualizarEstado(resource, event)}/>
                                                    <a href="#" className="btnPageModuloEditar" onClick={(event) => this.editRegistro(resource.pint_Id, event)}/>
													
													
													
                                                    <a href className="btnPageModuloEliminar aEliminarMenu2"/>
													<div className="c_divAlertaCapa">
														<div className="divAlertaCapa">
															<div className="divAlerta">
																<h2>&iquest;Seguro de eliminar?</h2>
																<div className="divAlertaBtn">
																	<a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(resource, event)}>ACEPTAR</a>
																	<a href="#" className="btnAlertaCancelar">CANCELAR</a>
																</div>
															</div>
														</div>
													</div>
													
													
													
                                                    </div>
                                                </td>
                                            </tr>
                                            ))

                                            :

                                            (<tr>
                                                <td colspan="7" className="tdSinResultados">
                                                    No se encontró resultados.
                                                </td>
                                            </tr>)
                                
                                : null
                            }

                        </tbody></table>
                    </div>
                    {this.paginationTable()}
                    <div className="clear" />
                    </div>

            </div>
        )
    }

    editRegistro(id, e){

        e.preventDefault();

        this.props.history.push({
            pathname: '/editar-puede-interesarte/' + id,
            state: { key: id,
                menuGeneral:this.state.menuGeneral,
                agrupador:this.state.agrupador }
          });
    }

    addRegistro(e){

        e.preventDefault();

        this.props.history.push({
            pathname: '/agregar-puede-interesarte',
            state: { totalRegistros: totalRegistros,
                menuGeneral:this.state.menuGeneral,
                agrupador:this.state.agrupador}
          });
    } 

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionButton(e);
        }
    }

    eliminarRegistro = async(entity, event) => {
        event.preventDefault();
        const url = `${API_URL}PuedeInteresarteUX/Eliminar`;

        let dataToSave=updateValueInJson(entity, 'pint_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        setTimeout(() => { 
                            this.executePagination(this.state.pagina);
                        }, 1000);  
                    } else 
                    {
                        this.setState({loading:false});
                        console.log('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    actualizarEstado = (entity, event) => {

        event.preventDefault();

        const url = `${API_URL}PuedeInteresarteUX/`;
        entity.pint_Activo = !entity.pint_Activo;
        let dataToSave=updateValueInJson(entity, 'pint_UsuarioEdicion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        setTimeout(() => { 
                            this.executePagination(this.state.pagina);
                        }, 1000);  
                    } else 
                    {                        
                        console.log('No se pudo procesar la solicitud \r');
                    }
                    this.setState({loading:false});
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    callFunctionButton = (event) => {

        event.preventDefault();

        var textoFilter = document.getElementById('texto_filter').value;
        this.setState({filters:{texto: textoFilter}});

        const url = (textoFilter != '') ? `${API_URL}PuedeInteresarteUX/1/${textoFilter}` : `${API_URL}PuedeInteresarteUX/1`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let offRows = 0;
            if(data.result.length > 0){
                offRows = data.result[0].offset * 1;
            }

            this.setState({ resource: data.result, response: data, error: data.Error, offRows:offRows});
			this.ShowPaginationFive(0);
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }
	
	executePaginationPrev(page, e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}

    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }
    
        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        let textoFilter = this.state.filters.texto;

        const url = (textoFilter != '') ? `${API_URL}PuedeInteresarteUX/${page}/${textoFilter}` : `${API_URL}PuedeInteresarteUX/${page}`;
        var entity = this.state.resource.length>0?this.state.resource[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
		$(".ipl-progress-indicator-head").css({"width": "90%"});

        axios.get(url).then(response => response.data)
        .then((data) => {
			
			$(".ipl-progress-indicator-head").css({"width": "100%"});
			setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
			}, 200);
			
            let offRows = 0;
            if(data.result.length > 0){
                offRows = data.result[0].offset;
            }

            this.setState({ resource: data.result, response: data, error: data.Error, pagina: page, offRows:offRows });
			this.ShowPaginationFive(page-1);
        })
        .catch(error => {
        });
    }

    paginationTable()
    {
        var entity = this.state.resource.length > 0 ? this.state.resource[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);
            
            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }
	
	ShowPaginationFive(pagina)
	{
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }
    
    loadMenus = (agrupador = "") => {

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";
        let sUrl = this.props.location.pathname;

        const url = `${API_URL}MenuUX/${rol}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

          let menuTemp = [{
            sAgrupador:"Administradores",
            sOpcNombre:"Menus",
            sUrl:"/menu"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorias de Certificaciones",
            sUrl:"/categorias-certificacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Exporta Fácil",
            sUrl:"/categorias-exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Preguntas Frecuentes",
            sUrl:"/categorias-faq"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Herramientas de Análisis",
            sUrl:"/categorias-herramienta-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Puede Interesarte",
            sUrl:"/categorias-puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Páginas",
            sUrl:"/paginas"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. de Análisis",
            sUrl:"/herramientas-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Certificaciones",
            sUrl:"/certificaciones"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Oficinas en el Mundo",
            sUrl:"/oficinas-mundo"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. También Puede Interesarte",
            sUrl:"/puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Documentación para Exportar",
            sUrl:"/documento-exportacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Guías para el Exportador",
            sUrl:"/guia-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Categorías Potencial de Exportación",
            sUrl:"/categorias-potencial-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Exporta Fácil",
            sUrl:"/exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Productos Priorizados por Sector y Mercado",
            sUrl:"/productos-priorizado"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. para Pymes",
            sUrl:"/herramientas-pyme"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. H. Externas",
            sUrl:"/herramientas-externa"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Programas de Capacitación",
            sUrl:"/programas-capacitacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Glosarios",
            sUrl:"/glosario"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. FAQ",
            sUrl:"/faqs"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Usuarios",
            sUrl:"/usuarios"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Roles",
            sUrl:"/perfiles"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Encuestas",
            sUrl:"/reporte-encuesta"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Logs",
            sUrl:"/reporte-logs"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Suscriptor",
            sUrl:"/reporte-suscriptor-footer"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Trazabilidad",
            sUrl:"/reporte-trazabilidad"
          },
          {
            sAgrupador:"Configuradores",
            sOpcNombre:"Panel de Configuración",
            sUrl:"/configuradores"
          }]

          menuTemp.map((menu) => (
            data.result.push(menu)
          ))
      
          var menuGeneral = data.result;

          validateUrl(menuGeneral, sUrl, ""); 

          if(menuGeneral != null){
            this.setState({
                menuGeneral: menuGeneral,
                agrupador: "Administradores"
            });
          }
      })
      .catch(error => {
          console.log(error);
      });
    }

    componentDidMount(){

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let newState = this.props.location.state;
        if(newState != undefined){  

            let sUrl = this.props.location.pathname;

            validateUrl(newState.menuGeneral, sUrl);     

            this.setState({
                menuGeneral: newState.menuGeneral,
                agrupador: newState.agrupador
            });            
        }else{
            this.loadMenus();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        const url = `${API_URL}PuedeInteresarteUX/1`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            let offRows = 0;
            if(data.result.length > 0){
                offRows = data.result[0].offset * 1;
                totalRegistros = data.result[0].totalRows;
            }

            this.setState({ resource: data.result, response: data, error: data.Error, roles : roles, pagina: 1, offRows:offRows });
			this.ShowPaginationFive(0);
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }
}
